(function () {
  'use strict';
  angular.module('vcpatdocs')
    .component('labreferral', {
      restrict: 'E',
      bindings: {
        parentsave: '&',
        reset: '<'
      },
      templateUrl: 'vcpatdocs/labreferral-component.tpl.html',
      controllerAs: 'vm',
      controller: ['$log', 'Config', 'Rlog', '$timeout',
        function ($log, Config, Rlog, $timeout) {
          let vm = this;

          vm.loadValues = loadValues;
          vm.toggleGroup = toggleGroup;
          vm.joinValues = joinValues;
          vm.flattenArray = flattenArray;
          vm.deleteLabVal = deleteLabVal;
          vm.undeleteLabVal = undeleteLabVal;


          vm.$onInit = function () {
            // reset/initialise resultset
            reset();
            //  get labvalues and groups from config
            Config.$find('labconfiguration').$then(labconfig => {
              vm.labconfig = labconfig;
            }, error => {
              Rlog.error('patdocs', 'newref', 'labconfiguration.$find() failed', {id: vm.clientid});
              $log.error('labconfiguration.$find() failed', error);
            });
          }; // $onInit()

          vm.$onChanges = function (changes) {
            if (!changes.isFirstChange) {
              if (angular.isDefined(changes.reset)) {
                reset();
              }
            }
          };


          function reset() {
            vm.labvalues = [];
            vm.allvalues = [];
            vm.ginclude = [];
            vm.selectedGroups = [];
            vm.deleteList = [];
            vm.additionalvalues = [];
          }

          function toggleGroup() {
            let tmpa = [];
            vm.selectedGroups = [];
            for (let i = 0; i < vm.labconfig.groups.length; i++) {
              if (vm.ginclude[i] === true) {
                tmpa = tmpa.concat(vm.labconfig.groups[i].values);
                vm.selectedGroups.push(vm.labconfig.groups[i]);
                cleanSelectedGroups();
              }
            }

            vm.autoselectedvalues = uniq(flattenArray(tmpa));
            joinValues();
          }


          function deleteLabVal(tag) {
            vm.deleteList.push(tag);
            cleanSelectedGroups();
          }

          function undeleteLabVal(tag) {
            joinValues();
            cleanSelectedGroups();
          }

          function cleanSelectedGroups() {
            vm.cleanGroups = [];
            vm.selectedGroups.map(function (group) {
              vm.cleanGroups.push({
                name: group.name, values: flattenArray(group.values).filter(function (e) {
                  return this.indexOf(e) < 0;
                }, flattenArray2(vm.deleteList))
              });
            });
            if (angular.isDefined(vm.additionalvalues) && vm.additionalvalues.length > 0) {
              vm.cleanGroups.push({
                name: 'Weiters', values: flattenArray(vm.additionalvalues).filter(function (e) {
                  return this.indexOf(e) < 0;
                }, flattenArray2(vm.deleteList))
              });
            }
            $log.debug('vm.cleanGroups: ', vm.cleanGroups);
          }

          function joinValues() {
            let tmpa = [];
            if (angular.isArray(vm.autoselectedvalues) && angular.isArray(vm.additionalvalues)) {
              tmpa = vm.autoselectedvalues.concat(flattenArray(vm.additionalvalues));
            }
            else {
              if (angular.isArray(vm.autoselectedvalues)) {
                tmpa = vm.autoselectedvalues;
              }
              if (angular.isArray(vm.additionalvalues)) {
                tmpa = flattenArray(vm.additionalvalues);
              }
            }
            vm.allvalues = uniq(tmpa);
            $log.debug('joinValues vm.allvalues:', vm.allvalues);
            // vm.deleteList =

            vm.filtered = vm.allvalues.filter(function (e) {
              return this.indexOf(e) < 0;
            }, flattenArray2(vm.deleteList));

            cleanSelectedGroups();

            // vm.parentsave({allvalues: vm.allvalues, ginclude: vm.ginclude, additionalvalues: vm.additionalvalues});
            vm.parentsave({allvalues: flattenArray2(vm.filtered), ginclude: vm.ginclude, additionalvalues: vm.additionalvalues, cleangroups: vm.cleanGroups});
          }



          function flattenArray(a) {
            let tmpa = [];
            if (angular.isArray(a)) {
              for (let i = 0; i < a.length; i++) {
                tmpa.push(a[i].name);
              }
            }
            return tmpa;
          }

          function flattenArray2(a) {
            let tmpa = [];
            if (angular.isArray(a)) {
              for (let i = 0; i < a.length; i++) {
                tmpa.push(a[i].text);
              }
            }
            return tmpa;
          }

          // make array values uniq
          function uniq(a) {
            return a.sort().filter(function (item, pos, ary) {
              return !pos || item !== ary[pos - 1];
            });
          }

          // load and filter autocomplete values
          function loadValues($query) {
            // ngtags needs a promise as input
            // eslint-disable-next-line no-unused-vars
            let promise = new Promise(function (resolve, reject) {
              resolve(vm.labconfig.values);
            });
            return promise.then(function (values) {
              let filteredValues = values.filter(function (value) {
                return value.name.toLowerCase().indexOf($query.toLowerCase()) !== -1;
              });
              $log.debug('filtered values: ', filteredValues);
              return filteredValues;
            });
          }


        }
      ] // controller
    }); // component

// klammerfriedhof
}());
